import { render, staticRenderFns } from "./BookingnoOverview.vue?vue&type=template&id=e68ca110&scoped=true"
import script from "./BookingnoOverview.vue?vue&type=script&lang=js"
export * from "./BookingnoOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e68ca110",
  null
  
)

export default component.exports